<template>
    <div>
        <myHeader></myHeader>
        <div class="contact_info_wrap">
            <div class="contact_info">
                <strong>欢迎联系我们</strong>
                <div class="info_tips">工作时间：{{siteInfo.work_time}}</div>
                <div class="contact_ul">
                    <div class="contact_li" v-for="(item,index) in company_list" :key="index">
                        <div class="li_left">
                            <b v-if="index > 8">{{index+1}}</b>
                            <b v-else>0{{index+1}}</b>
                            <span>{{item.company_name}}</span>
                        </div>
                        <div class="li_right">
                            <div class="li_right_name">
                                <b>{{item.contact_name}}</b>
                                <span><i></i>{{item.contact_tel}}</span>
                            </div>
                            <div class="li_right_email">{{item.email}}</div>
                            <div class="li_right_nr" v-html="item.company_address"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="map_wrap">
            <div class="map">
                <div id="container" class="container"></div>
            </div>
        </div>
        <div class="leave_wrap">
            <div class="leave">
                <div class="leave_left">
                    <img src="../../static/images/leave_left_img.png" alt="">
                </div>
                <div class="leave_right">
                    <strong>业务合作？在线留言！</strong>
                    <div class="leave_form">
                        <div class="leave_li">
                            <b>姓名：</b>
                            <el-input v-model="name" placeholder="请输入姓名" class="input_li"></el-input>
                        </div>
                        <div class="leave_li">
                            <b>邮箱：</b>
                            <el-input v-model="email" placeholder="请输入邮箱" class="input_li"></el-input>
                        </div>
                        <div class="leave_li">
                            <b>手机号：</b>
                            <el-input v-model="phone" placeholder="请输入手机号" class="input_li"></el-input>
                        </div>
                        <div class="leave_li leave_li_yzm">
                            <b>验证码：</b>
                            <el-input v-model="yzm" placeholder="请输入验证码" :maxlength="6"></el-input>
                            <button @click.prevent="getCode()"  class="code_btn" :disabled="!yzm_show">
                                <span v-show="yzm_show">{{yzm_text}}</span>
                                <span v-show="!yzm_show" class="count">{{count}} s</span>
                            </button>
                        </div>
                        <div class="leave_msg">
                            <b>留言：</b>
                            <el-input type="textarea" :rows="4" placeholder="留下您的只言片语..." v-model="textarea">
                            </el-input>
                        </div>
                        <button type="button" @click="submit()">提交</button>
                    </div>
                </div>
            </div>
        </div>
        <myFooter></myFooter>
        <el-dialog title="提交成功"
                   :visible.sync="tijiao_flag" class="tijiao">
            <div class="tijiao_form">
                <div class="tijiao_tips">
                    您已成功提交留言信息，稍后将会有工作人员与您联系。
                </div>
                <div class="tijiao_btn">
                    <button type="button" @click="tips_close()">我知道了</button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import myHeader from '../components/header.vue'
import MyFooter from '../components/footer.vue'
import {throttle } from "../axios/util.js";
import iconCar from '../../static/images/site_icon.png';
export default {
    name: 'contact',
    components: {MyFooter, myHeader},
    data () {
        return {
            company_list:[],
            siteInfo:{},
            name:'',
            email:'',
            phone:'',
            yzm:'',
            textarea:'',
            count:60,
            timer:null,
            yzm_show:true,
            yzm_text:'获取验证码',
            tijiao_flag:false
        }
    },
    created () {
        this.pageData();
        this.pageSiteMsg();
    },
    mounted() {
        this.mapAddListener1()
    },
    computed: {
        phoneRegex() {
            return /^1[3456789]\d{9}$/;
        },
        emailRegex() {
            return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
        },
    },
    methods:{
        pageData(){
            this.$api.companyList().then(res => {
                this.company_list = res.data;
            });
        },
        pageSiteMsg() {
            this.$api.siteMsg().then(res => {
                this.siteInfo = res.data.siteMsg;
            });
        },
        // 获取短信验证码
        getCode() {
            if (!this.phoneRegex.test(this.phone)) {
                this.$message.warning('请输入正确手机号码');
                return false;
            }
            if (!this.timer) {
                let params = {
                    mobile: this.phone
                };
                this.$api.getVerifyCode(params).then(res => {
                });
                this.count = 60;
                this.yzm_show = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= 60) {
                        this.count--;
                    } else {
                        this.yzm_show = true;
                        clearInterval(this.timer);
                        this.timer = null;
                        this.yzm_text = '重新发送'
                    }
                }, 1000);
            }
        },
        submit: throttle(function () {
            if (this.name==='') {
                this.$message.warning('请输入姓名');
                return false;
            }
            if (!this.emailRegex.test(this.email)) {
                this.$message.warning('请输入正确的邮箱');
                return false;
            }
            if (!this.phoneRegex.test(this.phone)) {
                this.$message.warning('请输入正确手机号码');
                return false;
            }
            if (this.textarea==='') {
                this.$message.warning('请输入留言内容');
                return false;
            }
            if (this.yzm==='') {
                this.$message.warning('请输入验证码');
                return false;
            }
            let params = {
                name:this.name,
                email: this.email,
                mobile: this.phone,
                content: this.textarea,
                code:this.yzm,
            };
            this.$api.submitMessage(params).then(res => {
                if(res.code===1){
                    setTimeout(()=>{
                        this.dialogVisible = false;
                        this.name = '';
                        this.email = ''
                        this.phone=''
                        this.textarea=''
                        this.yzm=''
                        this.tijiao_flag = true
                    }, 500);
                }else{
                    this.$message.warning('提交失败，请重新提交！')
                }
            });
        }, 1000),
        tips_close(){
            this.tijiao_flag = false;
        },
        mapAddListener1(){
            var points = []
            this.$api.companyList().then(res => {
                points = res.data;
                var map = new BMap.Map("container")
                // 拖拽地图
                map.enableDragging()
                // 地图缩放
                map.enableScrollWheelZoom()
                // 标记点添加点击事件
                const createMarker = (item) => {
                    // 创建坐标点
                    var point = new BMap.Point(item.lng, item.lat)
                    // 设置地图中心
                    map.centerAndZoom(point, 1)
                    // 创建点标记
                    var myIcon = new BMap.Icon(iconCar, new BMap.Size(32, 32))
                    var marker = new BMap.Marker(point, {icon: myIcon})
                    var labelopts = {
                        // 指定文本标注所在的地理位置
                        position: point,
                        // 设置文本偏移量
                        offset: new BMap.Size(0, 0)
                    };
                    // 设置标记样式
                    var label = new BMap.Label('', labelopts);
                    label.setStyle({
                    })
                    map.addOverlay(label)
                    map.addOverlay(marker)
                    // 信息内容
                    var content =
                            '<ul style="margin:0 0 5px 0;padding:0.2em 0">'
                            +'<li style="line-height: 20px;font-size: 12px;">'
                            +'<span style="width: 50px;display: inline-block;text-align:right;">名称: </span>' + item.company_name + '</li>'
                            +'<li style="line-height: 20px;font-size: 12px;">'
                            +'<span style="width: 50px;display: inline-block;text-align:right;">地址: </span>' + item.company_address + '</li>'
                            +'<li style="line-height: 20px;font-size: 12px;">'
                            +'<span style="width: 50px;display: inline-block;text-align:right;">联系人: </span>' + item.contact_name + '</li>'
                            +'<li style="line-height: 20px;font-size: 12px;">'
                            +'<span style="width: 50px;display: inline-block;text-align:right;">电话: </span>' + item.contact_tel + '</li>'
                            +'</ul>'
                    var infoWindow = new BMap.InfoWindow(content)
                    marker.addEventListener('click', function(){
                        map.openInfoWindow(infoWindow, point)
                    });
                }
                // 循环标记点添加点击事件
                points.forEach((point) => {
                    createMarker(point)
                })
            });
        }
    }
}
</script>


<style scoped>
.tijiao{width:100%;}
/deep/ .tijiao .el-dialog{width:400px;}
/deep/ .tijiao .el-dialog__header{text-align:center;}
/deep/ .tijiao .el-dialog__title{font-weight:bold;}
/deep/ .tijiao .el-dialog__body{border-top:1px solid #eee;padding:20px 20px 30px;}
.tijiao_form{width:100%;min-height:100px;height:auto;}
.tijiao_tips{width:100%;height:auto;font-size:14px;color:#333;line-height:24px;display:block;text-align:center;}
.tijiao_btn{margin-top:30px;padding:0;}
.tijiao_btn button{width:100%;height:44px;background:#0c57c3;font-size:16px;color:#fff;line-height:44px;
    text-align:center;display:block;cursor:pointer;transform:0.8s;}
.tijiao_btn button:hover{background: #1b5fc3;transform:0.8s;}
.contact_info_wrap{width:100%;min-height:200px;height:auto;float:left;background:#f5f5f5;}
.contact_info{width:1200px;height:auto;min-height:200px;display:block;position:relative;left:50%;margin-left:-600px;padding:50px 0 60px;float:left;}
.contact_info strong{width:100%;height:50px;font-size:28px;color:#000;line-height:50px;display:block;float:left;text-align:center;letter-spacing:2px;}
.info_tips{width:100%;height:20px;font-size:14px;color:#333;line-height:20px;text-align:center;margin-top:10px;float:left;}
.contact_ul{width:100%;height:auto;float:left;margin-top:40px;}
.contact_ul .contact_li{width:380px;height:180px;background:#fff;display:inline-block;float:left;margin-left:30px;margin-top:30px;}
.contact_ul .contact_li:nth-child(3n-2){margin-left:0;}
.contact_ul .contact_li:nth-child(1){margin-top:0;}
.contact_ul .contact_li:nth-child(2){margin-top:0;}
.contact_ul .contact_li:nth-child(3){margin-top:0;}
.li_left{width:120px;height:180px;display:inline-block;position:relative;float:left;}
.li_left b{width:100%;height:180px;font-size:72px;color:#0a64ba;opacity:0.1;line-height:180px;text-align:center;display:block;}
.li_left span{width:100%;height:180px;display:flex;font-size:16px;color:#0a64ba;font-weight:bold;line-height:30px;text-align:center;
    z-index:10;position:absolute;left:0;top:0;align-items: center;justify-content: center;}
.li_right{width:260px;height:180px;display:inline-block;float:left;padding:15px 15px 5px;}
.li_right_name{width:100%;height:20px;display:block;float:left;overflow:hidden;}
.li_right_name b{width:35%;height:20px;display:inline-block;float:left;font-size:15px;color:#000;font-weight:bold;line-height:20px;
    overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.li_right_name span{width:65%;height:20px;display:inline-block;float:left;font-size:14px;color:#000;line-height:20px;text-align:left;}
.li_right_name span i{width:12px;height:12px;display:inline-block;background:url(../../static/images/tel_icon.png) center no-repeat;
    background-size:12px 12px;vertical-align:top;margin:4px 5px 4px 0;}
.li_right_email{width:100%;height:30px;display:block;float:left;overflow:hidden;line-height:30px;}
.li_right_nr{width:100%;height:96px;display:inline-flex;float:left;margin-top:0;font-size:12px;color:#000;line-height:16px;
    overflow: hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
    display: -webkit-box;-webkit-line-clamp:6;-webkit-box-orient: vertical;}
.map_wrap{width:100%;height:540px;display:block;float:left;background:url(../../static/images/map_bg.png) center no-repeat;
    background-size:1920px 540px;padding:70px 0;}
.map{width:1200px;height:400px;display:block;margin:0 auto;}
.map img{width:100%;height:auto;display:block;}
.leave_wrap{width:100%;height:700px;display:block;float:left;background:url(../../static/images/leave_bg.jpg) center no-repeat;
    background-size:1920px 700px;padding:50px 0;}
.leave{width:1200px;height:600px;display:block;margin:0 auto;}
.leave_left{width:650px;height:600px;display:inline-block;float:left;}
.leave_left img{width:100%;height:auto;display:block;}
.leave_right{width:550px;height:600px;display:inline-block;float:left;padding-left:60px;}
.leave_right strong{width:100%;height:40px;font-size:24px;display:inline-block;float:left;color:#fff;line-height:40px;font-weight:normal;margin-top:20px;}
.leave_form{width:100%;height:540px;display:block;float:left;padding-top:20px;}
.leave_li{width:100%;height:45px;display:inline-block;float:left;margin-top:25px;border-bottom:1px solid;border-color: rgba(255,255,255,0.2);
    position:relative;padding-left:60px;padding-bottom:5px;}
.leave_li b{width:60px;font-size:14px;color:#fff;line-height:40px;height:40px;position:absolute;left:0;bottom:5px;z-index:10;font-weight:normal;opacity:0.9;}
/deep/ .leave_li .el-input__inner{border-radius:0;border-color:transparent;color:#fff;background:transparent;}
/deep/ .leave_li .el-input.is-active .el-input__inner,
/deep/ .leave_li .el-input__inner:focus{border-color:transparent;}
/deep/ .leave_li .el-input__inner::-webkit-input-placeholder{color:rgba(255,255,255,0.3);}
/deep/ .leave_li .el-input__inner::-moz-placeholder{color:rgba(255,255,255,0.3);}
/deep/ .leave_li .el-input__inner:-ms-input-placeholder{color:rgba(255,255,255,0.3);}
/deep/ .leave_li .el-input__inner:-moz-placeholder{color:rgba(255,255,255,0.3);}
.leave_msg{width:100%;min-height:40px;height:auto;display:inline-block;float:left;margin-top:25px;}
.leave_msg b{width:100px;font-size:14px;color:#fff;line-height:40px;height:40px;float:left;font-weight:normal;opacity:0.9;}
/deep/ .leave_li:hover{border-color:rgba(255,255,255,1.0); }
/deep/ .leave_msg .el-textarea__inner{background:transparent;border-color:rgba(255,255,255,0.2);color:#fff;border-radius:0;font-size:14px;
    padding:10px 15px;font-family: Microsoft YaHei;font-weight:normal;}
/deep/ .leave_msg .el-textarea__inner:hover{border-color:rgba(255,255,255,1.0);}
/deep/ .leave_msg .el-textarea__inner:focus{border-color:rgba(255,255,255,1.0);}
/deep/ .leave_msg .el-textarea__inner::-webkit-input-placeholder{color:rgba(255,255,255,0.3);}
/deep/ .leave_msg .el-textarea__inner::-moz-placeholder{color:rgba(255,255,255,0.3);}
/deep/ .leave_msg .el-textarea__inner:-ms-input-placeholder{color:rgba(255,255,255,0.3);}
/deep/ .leave_msg .el-textarea__inner:-moz-placeholder{color:rgba(255,255,255,0.3);}
.leave_form button{width:140px;height:46px;display:block;background:#0a64ba;font-size:15px;float:left;margin-top:23px;opacity:0.8;
    color:#fff;line-height:46px;text-align:center;border-radius:4px;letter-spacing:2px;cursor:pointer;transform: 0.8s;}
.leave_form button:hover{background:#0c57c3;transform: 0.8s;opacity:1.0;}
/deep/ .leave_li.leave_li_yzm .el-input{padding-right:110px;}
.leave_li.leave_li_yzm .code_btn{width:120px;height:40px;position:absolute;right:0;bottom:5px;z-index:2;
    background:#0a64ba;font-size:13px;color:#fff;cursor:pointer;line-height:40px;transform:0.8s;}
.leave_li.leave_li_yzm .code_btn:hover{background: #0c57c3;transform:0.8s;}
.container{width:100%;height:400px;}
@media (min-width:992px) and (max-width:1200px){
    /deep/ .tijiao .el-dialog{width:360px;}
    /deep/ .tijiao .el-dialog__body{border-top:1px solid #eee;padding:15px 20px 20px;}
    .tijiao_form{min-height:80px;height:auto;}
    .tijiao_tips{font-size:12px;line-height:20px;}
    .tijiao_btn{margin-top:30px;padding:0;}
    .tijiao_btn button{height:40px;font-size:15px;line-height:40px;}
    .contact_info_wrap{min-height:200px;}
    .contact_info{width:1000px;min-height:200px;margin-left:-500px;padding:40px 0 50px;}
    .contact_info strong{height:40px;font-size:24px;line-height:40px;}
    .info_tips{height:20px;font-size:12px;line-height:20px;margin-top:5px;}
    .contact_ul{margin-top:30px;}
    .contact_ul .contact_li{width:485px;height:150px;background:#fff;display:inline-block;float:left;margin-left:30px;margin-top:20px;}
    .contact_ul .contact_li:nth-child(3n-2){margin-left:0;}
    .contact_ul .contact_li:nth-child(2n-1){margin-left:0;}
    .contact_ul .contact_li:nth-child(1){margin-top:0;margin-left:0;}
    .contact_ul .contact_li:nth-child(2){margin-top:0;}
    .contact_ul .contact_li:nth-child(3){margin-top:20px;margin-left:0;}
    .contact_ul .contact_li:nth-child(4){margin-top:20px;margin-left:30px;}
    .li_left{width:120px;height:150px;display:inline-block;position:relative;float:left;}
    .li_left b{width:100%;height:150px;font-size:72px;color:#0a64ba;opacity:0.1;line-height:150px;text-align:center;display:block;}
    .li_left span{width:100%;height:150px;display:flex;font-size:16px;color:#0a64ba;font-weight:bold;line-height:30px;text-align:center;
        z-index:10;position:absolute;left:0;top:0;}
    .li_right{width:360px;height:150px;display:inline-block;float:left;padding:15px 15px 5px 5px;}
    .li_right_name{width:100%;height:20px;display:block;float:left;overflow:hidden;}
    .li_right_name b{width:35%;height:20px;display:inline-block;float:left;font-size:15px;color:#000;font-weight:bold;line-height:20px;
        overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
    .li_right_name span{width:65%;height:20px;display:inline-block;float:left;font-size:14px;color:#000;line-height:20px;text-align:left;}
    .li_right_name span i{width:12px;height:12px;display:inline-block;background:url(../../static/images/tel_icon.png) center no-repeat;
        background-size:12px 12px;vertical-align:top;margin:4px 5px 4px 0;}
    .li_right_email{height:30px;line-height:30px;}
    .li_right_nr{width:100%;height:80px;display:inline-flex;float:left;margin-top:0;font-size:12px;color:#000;line-height:16px;
        overflow: hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:5;-webkit-box-orient: vertical;}
    .map_wrap{width:100%;height:440px;display:block;float:left;background:url(../../static/images/map_bg.png) center no-repeat;
        background-size:1920px 440px;padding:50px 0;}
    .map{width:1000px;height:340px;}
    .container{width:100%;height:340px;}
    .leave_wrap{width:100%;height:580px;background:url(../../static/images/leave_bg.jpg) center no-repeat;
        background-size:1920px 580px;padding:40px 0;}
    .leave{width:1000px;height:500px;}
    .leave_left{width:550px;height:500px;}
    .leave_right{width:450px;height:500px;padding-left:50px;}
    .leave_right strong{height:36px;font-size:20px;line-height:36px;margin-top:0;}
    .leave_form{height:460px;padding-top:10px;}
    .leave_li{width:100%;height:45px;margin-top:15px;padding-left:60px;padding-bottom:5px;}
    .leave_li b{width:60px;font-size:14px;line-height:40px;height:40px;bottom:5px;}
    .leave_msg{min-height:40px;margin-top:15px;}
    .leave_msg b{width:100px;font-size:14px;color:#fff;line-height:40px;height:40px;float:left;font-weight:normal;opacity:0.9;}
    /deep/ .leave_msg .el-textarea__inner{font-size:14px;padding:10px 15px;}
    .leave_form button{width:120px;height:36px;font-size:14px;margin-top:15px;line-height:36px;}
    /deep/ .leave_li.leave_li_yzm .el-input{padding-right:110px;}
    .leave_li.leave_li_yzm .code_btn{width:120px;height:40px;bottom:5px;font-size:12px;line-height:40px;}
}
@media (min-width:768px) and (max-width:991px){
    /deep/ .tijiao .el-dialog{width:360px;}
    /deep/ .tijiao .el-dialog__body{border-top:1px solid #eee;padding:15px 20px 20px;}
    .tijiao_form{min-height:80px;height:auto;}
    .tijiao_tips{font-size:12px;line-height:20px;}
    .tijiao_btn{margin-top:30px;padding:0;}
    .tijiao_btn button{height:40px;font-size:15px;line-height:40px;}
    .contact_info_wrap{min-height:200px;}
    .contact_info{width:750px;min-height:200px;margin-left:-375px;padding:30px 0 40px;}
    .contact_info strong{height:40px;font-size:24px;line-height:40px;}
    .info_tips{height:20px;font-size:12px;line-height:20px;margin-top:5px;}
    .contact_ul{margin-top:30px;}
    .contact_ul .contact_li{width:370px;height:160px;background:#fff;display:inline-block;float:left;margin-left:10px;margin-top:10px;}
    .contact_ul .contact_li:nth-child(3n-2){margin-left:0;}
    .contact_ul .contact_li:nth-child(2n-1){margin-left:0;}
    .contact_ul .contact_li:nth-child(1){margin-top:0;margin-left:0;}
    .contact_ul .contact_li:nth-child(2){margin-top:0;}
    .contact_ul .contact_li:nth-child(3){margin-top:10px;margin-left:0;}
    .contact_ul .contact_li:nth-child(4){margin-top:10px;margin-left:10px;}
    .li_left{width:100px;height:160px;display:inline-block;position:relative;float:left;}
    .li_left b{width:100%;height:160px;font-size:72px;color:#0a64ba;opacity:0.1;line-height:160px;text-align:center;display:block;}
    .li_left span{width:100%;height:160px;display:flex;font-size:16px;color:#0a64ba;font-weight:bold;line-height:30px;text-align:center;
        z-index:10;position:absolute;left:0;top:0;}
    .li_right{width:270px;height:160px;display:inline-block;float:left;padding:10px 10px 5px 0;}
    .li_right_name{width:100%;height:20px;display:block;float:left;overflow:hidden;}
    .li_right_name b{width:35%;height:20px;display:inline-block;float:left;font-size:15px;color:#000;font-weight:bold;line-height:20px;
        overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
    .li_right_name span{width:65%;height:20px;display:inline-block;float:left;font-size:14px;color:#000;line-height:20px;text-align:left;}
    .li_right_name span i{width:12px;height:12px;display:inline-block;background:url(../../static/images/tel_icon.png) center no-repeat;
        background-size:12px 12px;vertical-align:top;margin:4px 5px 4px 0;}
    .li_right_email{height:30px;line-height:30px;}
    .li_right_nr{width:100%;height:96px;display:inline-flex;float:left;margin-top:0;font-size:12px;color:#000;line-height:16px;
        overflow: hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:6;-webkit-box-orient: vertical;}
    .map_wrap{width:100%;height:400px;display:block;float:left;background:url(../../static/images/map_bg.png) center no-repeat;
        background-size:1920px 400px;padding:50px 0;}
    .map{width:750px;height:300px;}
    .container{width:100%;height:300px;}
    .leave_wrap{width:100%;height:580px;background:#313131;padding:40px 0;}
    .leave{width:750px;height:500px;}
    .leave_left{width:550px;height:500px;display:none;}
    .leave_right{width:100%;height:500px;padding-left:0;}
    .leave_right strong{height:36px;font-size:20px;line-height:36px;margin-top:0;}
    .leave_form{height:460px;padding-top:10px;}
    .leave_li{width:100%;height:45px;margin-top:15px;padding-left:60px;padding-bottom:5px;}
    .leave_li b{width:60px;font-size:14px;line-height:40px;height:40px;bottom:5px;}
    .leave_msg{min-height:40px;margin-top:15px;}
    .leave_msg b{width:100px;font-size:14px;color:#fff;line-height:40px;height:40px;float:left;font-weight:normal;opacity:0.9;}
    /deep/ .leave_msg .el-textarea__inner{font-size:14px;padding:10px 15px;}
    .leave_form button{width:120px;height:36px;font-size:14px;margin-top:15px;line-height:36px;}
    /deep/ .leave_li.leave_li_yzm .el-input{padding-right:110px;}
    .leave_li.leave_li_yzm .code_btn{width:120px;height:40px;bottom:5px;font-size:12px;line-height:40px;}
}
@media (max-width:767px){
    /deep/ .tijiao .el-dialog{width:300px;}
    /deep/ .tijiao .el-dialog__body{border-top:1px solid #eee;padding:15px 20px 20px;}
    .tijiao_form{min-height:80px;height:auto;}
    .tijiao_tips{font-size:12px;line-height:20px;}
    .tijiao_btn{margin-top:30px;padding:0;}
    .tijiao_btn button{height:40px;font-size:15px;line-height:40px;}
    .contact_info_wrap{min-height:200px;}
    .contact_info{width:100%;min-height:200px;margin-left:0;padding:20px 15px 30px;left:0;}
    .contact_info strong{height:30px;font-size:20px;line-height:30px;}
    .info_tips{height:20px;font-size:12px;line-height:20px;margin-top:5px;}
    .contact_ul{margin-top:20px;}
    .contact_ul .contact_li{width:100%;min-height:130px;height:auto;background:#fff;display:inline-block;float:left;margin-left:0;margin-top:10px;}
    .contact_ul .contact_li:nth-child(3n-2){margin-left:0;}
    .contact_ul .contact_li:nth-child(2n-1){margin-left:0;}
    .contact_ul .contact_li:nth-child(1){margin-top:0;margin-left:0;display: flex;align-items:center;}
    .contact_ul .contact_li:nth-child(2){margin-top:10px;}
    .contact_ul .contact_li:nth-child(3){margin-top:10px;margin-left:0;}
    .contact_ul .contact_li:nth-child(4){margin-top:10px;margin-left:0;}
    .li_left{width:30%;min-height:130px;height:auto;display:inline-block;position:relative;float:left;}
    .li_left b{width:100%;min-height:130px;height:auto;font-size:72px;color:#0a64ba;opacity:0.1;line-height:130px;text-align:center;display:block;}
    .li_left span{width:100%;min-height:130px;height:auto;display:flex;font-size:16px;color:#0a64ba;font-weight:bold;line-height:30px;text-align:center;
        z-index:10;position:absolute;left:0;top:0;}
    .li_right{width:70%;min-height:130px;height:auto;display:inline-block;float:left;padding:10px 15px 5px;}
    .li_right_name{width:100%;height:20px;display:block;float:left;overflow:hidden;}
    .li_right_name b{width:35%;height:20px;display:inline-block;float:left;font-size:15px;color:#000;font-weight:bold;line-height:20px;
        overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
    .li_right_name span{width:65%;height:20px;display:inline-block;float:left;font-size:14px;color:#000;line-height:20px;text-align:left;}
    .li_right_name span i{width:12px;height:12px;display:inline-block;background:url(../../static/images/tel_icon.png) center no-repeat;
        background-size:12px 12px;vertical-align:top;margin:4px 5px 4px 0;}
    .li_right_email{height:30px;line-height:30px;}
    .li_right_nr{width:100%;min-height:64px;height:auto;display:inline-flex;float:left;margin-top:0;font-size:12px;color:#000;line-height:16px;
        overflow: hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;
        display: -webkit-box;-webkit-line-clamp:14;-webkit-box-orient: vertical;}
    .map_wrap{display:none;}
    .map{display:none;}
    .leave_wrap{width:100%;height:440px;background:#313131;padding:30px 15px;}
    .leave{width:100%;height:380px;}
    .leave_left{width:550px;height:500px;display:none;}
    .leave_right{width:100%;height:380px;padding-left:0;}
    .leave_right strong{height:30px;font-size:16px;line-height:30px;margin-top:0;}
    .leave_form{height:350px;padding-top:10px;}
    .leave_li{width:100%;height:35px;margin-top:10px;padding-left:60px;padding-bottom:5px;}
    .leave_li b{width:60px;font-size:13px;line-height:30px;height:30px;bottom:5px;}
    .leave_msg{min-height:30px;margin-top:10px;}
    .leave_msg b{width:100px;font-size:13px;color:#fff;line-height:30px;height:30px;float:left;font-weight:normal;opacity:0.9;}
    /deep/ .leave_li .el-input__inner{height:30px;line-height:30px;}
    /deep/ .leave_msg .el-textarea__inner{font-size:14px;padding:5px 10px;}
    .leave_form button{width:100px;height:30px;font-size:12px;margin-top:10px;line-height:30px;}
    /deep/ .leave_li.leave_li_yzm .el-input{padding-right:110px;}
    .leave_li.leave_li_yzm .code_btn{width:100px;height:30px;bottom:5px;font-size:12px;line-height:30px;}
}
</style>



// WEBPACK FOOTER //
// src/pages/contact.vue